<template>
  <div>
    <el-upload
      id="upload"
      ref="upload"
      :action="action"
      :file-list="fileListModel"
      :on-success="onUploadFinished"
      :on-change="changeFile"
      :auto-upload="false"
      :on-remove="handleRemove"
      :on-preview="handlePreview"
      :disabled="readOnly"
      :on-exceed="onExceed"
      :limit="limit"
      v-bind="proxyAttrs"
    >
      <el-button v-if="!readOnly" class="up">选择稿件(不超过10M)</el-button>
      <div style="font-size:13px;margin-left: 0px;text-align: left;color:red">注：需上传论文内容摘要、论文全文两个附件</div>
    </el-upload>
    <el-button v-if="!readOnly" class="down" @click="submitUpload"
      >点击上传稿件</el-button
    >
  </div>
</template>

<script>
export default {
  name: "paperUpload",
  props: {
    value: {
      type: [Array, String],
      default: "",
    },
    autoUpload: {
      type: Boolean,
      default: false,
      comment: "autoUpload",
    },
    uloadFilesList: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 1,
      comment: "limit",
    },
    showFileList: {
      type: Boolean,
      default: true,
      comment: "showFileList",
    },
    readOnly: {
      // 是否只显示文件信息，不支持上传操作
      type: Boolean,
      default: false,
    },
    uploadFileList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    uploadFileList: {
      handler(v) {
        if (v) {
          this.storelist = JSON.parse(JSON.stringify(v));
          this.fileListModel = v.map((item) => {
            return { name: item.filename, url: item.url };
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    modelValue({ value }) {
      let shit = [];
      if (this.storelist) {
        shit = this.storelist.map((item) => {
          return { name: item.filename, url: item.url };
        });
      }
      return shit;
      // return (value && [{ url: value }]) || [];
    },
    action() {
      // 是readOnly传空值，否则从属性获取
      if (this.readOnly) {
        return "";
      } else {
        return this.$attrs.action;
      }
    },
    proxyAttrs() {
      // 由于action的值和readOnly有关，单独拿出来
      const { action, ...others } = this.$attrs;
      return others;
    },
  },
  data() {
    return {
      storelist: [],
      fileListModel: [],
      fileList: [],
    };
  },
  methods: {
    onUploadFinished({ code, data }) {
      if (code !== 200) return this.$message.error("文件上传失败！");
      this.$emit("input", data);
    },
    changeFile(file, list) {
      if (
        this.fileListModel &&
        this.fileListModel.some((item) => item.name == file.name)
      ) {
        this.$message("上传稿件名称不能相同，请重新上传");
        this.fileListModel = this.fileListModel.slice();
        return;
      }
      let isLt2M = true;
      isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.loading = false;
        this.$message.error("上传文件大小不能超过 100MB!"); // 限制它的上传大小
        this.fileListModel = []; // 不满足要求清空即可
      } else {
        list.forEach((x) => {
          if (x.status === "ready") {
            this.fileList.push(x.raw);
            this.fileListModel.push(x.raw);
          }
        });
      }
    },
    submitUpload() {
      this.uploading = true;
      if (this.fileList && this.fileList.length > 0) {
        for (const file of this.fileList) {
          this.$store.dispatch("file/upload", file).then((upload_req) => {
            this.storelist = this.storelist.concat(upload_req);
            this.$emit("input", this.storelist);
          });
        }
        this.$message("上传成功！");
        this.fileList = [];
      } else {
        this.$message("请选择稿件");
      }
    },
    onExceed(file, fileList) {
      this.$message("最多只能上传2个附件，如需替换请点击文件右侧的按钮先删除");
    },
    handleRemove(file, fileList) {
      if (this.storelist && this.storelist.length == 0) {
        this.fileListModel = this.fileListModel.filter((item) => item.name != file.name);
        this.fileList = this.fileList.filter((item) => item.name != file.name);
      } else {
        this.storelist = this.storelist.filter((item) => item.filename != file.name);
        this.$emit("input", this.storelist);
      }
    },
    handlePreview(file_item) {
      window.open(file_item.url);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload {
  display: block;
  width: 100%;
}
.up {
  display: block;
  width: 100%;
  height: 100%;
  background: transparent;

  &:focus,
  &:hover {
    border-color: #fe0000;
    color: #fe0000;
  }
}
.down {
  display: block;
  width: 100%;
  height: 100%;
  background: transparent;

  &:focus,
  &:hover {
    border-color: green;
    color: green;
  }
}
</style>
